const e = "Ação esgotou o tempo. Por favor, verifique sua conexão com a internet e tente novamente.", o = { 400: "Este endereço de email não está registrado no $t(_company). Por favor, verifique se está correto ou inscreva-se abaixo.", 404: "$t(responses.login.400)", 500: "$t(responses.default)" }, s = { 400: "$t(responses.default)", 500: "$t(responses.default)" }, a = { 2033: "Sessão criada com sucesso.", 2064: "Sessão atualizada com sucesso." }, t = { 200: "Sua primeira sessão foi criada com sucesso.", 201: "$t(responses.dashboardSession.200)" }, r = { 2084: "Solicitação de acesso à sessão já estava em estado aprovado", 2088: "Você já solicitou acesso a esta sessão.", email: { 200: "Pessoas adicionadas" }, domain: { 200: "Grupo adicionado" } }, n = { 200: "Ótimo! Vamos mantê-lo(a) atualizado(a)." }, i = { 404: "$t(responses.default)", 405: "O código de verificação está incorreto. Por favor, verifique novamente.", 500: "$t(responses.default)" }, c = { 500: "Desculpe, algo deu errado. Por favor, tente novamente.", avatar: { 400: "Erro ao salvar avatar. Por favor, tente novamente." } }, d = {
  default: "Desculpe, algo deu errado. Por favor, tente novamente.",
  timeout: e,
  login: o,
  register: s,
  session: a,
  dashboardSession: t,
  sessionAccess: r,
  subscribe: n,
  verify: i,
  user: c
};
export {
  t as dashboardSession,
  d as default,
  o as login,
  s as register,
  a as session,
  r as sessionAccess,
  n as subscribe,
  e as timeout,
  c as user,
  i as verify
};
